import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/default.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const LineLargeAlt = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="240px"
        height="6px"
        viewBox="0 0 240 6"
        className={classNames([styles.container, { [className]: className !== null }])}
        xmlSpace="preserve"
    >
        <g>
            <path
                fill={color}
                d="M237.4,1.2c-0.3-0.1-0.6-0.3-0.7-0.3c-0.5,0.2-0.6,0-0.7-0.2c-0.3-0.6-1.2-0.2-1.8-0.3c-0.7,0.8-1.5,0-2.2,0.1
        		c-0.5,0.1-1.1,0.3-1.4,0.2c-1.1-0.4-2.3-0.2-3.4-0.2c-0.7,0.1-1.1,0-1.6-0.5c-0.2,0.4-0.3,0.7-0.5,1.1c-1.3-0.9-2.8-0.9-4.3-0.5
        		c-0.3-0.2-0.6-0.3-0.8-0.5c-0.3,0.1-0.6,0.2-0.8,0.3c-0.2,0.1-0.5,0.2-1,0.3c-0.2-0.2-0.3-0.4-0.3-0.4c-0.9,0.1-1.8,0.4-2.3,0.2
        		c-1.2-0.3-2.4-0.1-3.6,0c-1.2,0.1-2.6,0.4-3.4-0.3c-0.6,0.1-1,0.2-1.4,0.2c-0.5,0-0.9-0.2-1.4-0.3c-0.3,0.4-0.8,0.6-1.5,0.4
        		c-0.5-0.1-1-0.2-1.5-0.3c-0.7-0.1-1.5-0.1-1.8,0.4c-0.6-0.2-1.2-0.4-1.7-0.6c-0.4,0.3-0.7,0.4-1.1,0.7c-0.2-0.3-0.3-0.5-0.4-0.7
        		c-0.7,0-1.4-0.1-1.3,0.5c-0.5,0-1,0-1.4,0c-0.3,0-0.7,0.1-1,0.1c-0.9-0.2-1.7-0.5-2.5,0c-0.1,0-0.3,0-0.3,0c-0.6-0.3-1.3-0.1-2-0.1
        		c-0.3,0-0.6-0.2-0.9-0.3c-1.1,0.4-1.1,0.4-3.3,0c0,0.2-0.1,0.4-0.1,0.6c-1.7-0.3-3.3-0.6-4.9-0.1c-1.2-0.3-2.7,0.4-3.5-0.3
        		c-0.6,0.1-1.1,0.2-1.6,0.4c-0.3-0.2-0.6-0.4-0.9-0.6c-0.3,0.2-0.4,0.4-0.5,0.5c-0.9-0.1-1.7-0.2-2.4-0.1c-0.8,0.1-1.5,0.1-2.2-0.2
        		c-0.2-0.1-0.5-0.1-0.8-0.2c-0.1,0.2-0.1,0.4-0.2,0.7c-0.8-0.2-1.6-0.3-2.3-0.5c-0.1,0-0.2,0-0.3,0.1c-0.4,0.2-0.8,0.4-1.2,0.6
        		c-0.1-0.1-0.3-0.3-0.4-0.5c-0.6,0.1-1,0.2-1.4,0.2c-0.4,0-0.6-0.3-0.8-0.4c-0.6,0.1-1.2,0.4-1.6,0.4c-2.1-0.2-4.2,0-6.2-0.3
        		c-0.3,0-0.7-0.1-0.8,0c-1.3,0.7-2.7-0.1-4.1,0.1c-1-0.7-1.6-0.1-2.2,0.3c-0.8-0.6-1.6-0.8-2.6-0.3c-0.2,0.1-0.5,0.1-0.7,0.1
        		c-1.1-0.2-1.9,0.1-2.6,0.5C140.2,1,140,0.7,140,0.7c-1.2,0.2-2.4-0.1-3.6-0.1c-1.5,0-3.1,0.4-4.6,0.1c-1,0.4-1.8,0-2.7-0.2
        		c-0.3-0.1-0.9-0.1-0.9-0.1c-0.8,0.8-1.5,0.2-2.2-0.1c-1.4,0.4-1.6,0.4-1.7-0.5c-0.4,0.4-0.7,0.6-1.1,1c-0.9-0.7-2.3,0.2-3.3-0.5
        		c-0.2,0.3-0.4,0.5-0.6,0.8c-0.7-0.3-1.4-0.6-2-0.9c-1.1,0.6-2.4,0-3.6,0.2c0,0.1,0,0.3,0,0.4c-1.1,0.1-2,0-2.6-0.6
        		c-0.7,0.1-1.1,0.8-2,0.5c-1.2-0.5-1.3,0.2-1.8,0.5c-0.6-0.3-1-1.1-2-0.3c-0.3-0.3-0.6-0.5-0.8-0.7c-0.7,0.2-1.1,0.3-1.5,0.4
        		c-0.2-0.2-0.3-0.3-0.4-0.4c-0.6,0.2-1.2,0.3-1.8,0.5c-0.2-0.2-0.4-0.3-0.6-0.5c-0.4,0.2-0.7,0.4-1.2,0.7c-0.2-0.3-0.4-0.5-0.6-0.7
        		c-1.1,0.5-2.2,0.7-3.2,0.4c-1.5-0.3-2.7-0.2-4,0.1c-0.7-0.1-1.3-0.1-1.8-0.2c-0.8-0.2-0.9,0.5-1.6,0.3c-0.3-0.2-0.6-0.4-0.9-0.6
        		c-0.6,0.3-1.1,0.5-1.5,0.7c-0.7-0.2-1.4-0.4-2.1-0.6c-0.3,0.2-0.5,0.4-0.7,0.5c-0.3,0-0.7-0.1-1-0.1c-0.4,0-0.8,0-1.2-0.1
        		c-0.8-0.1-1.7-0.5-2.3,0.2c-0.9-0.4-2.1,0.1-3-0.4c-0.4-0.2-0.8-0.2-1,0.1C74,0.9,73.6,0.9,73.2,1c-0.3,0-0.5,0.2-0.7,0.3
        		c-0.2-0.1-0.4-0.2-0.5-0.3c-0.2-0.1-0.4-0.2-0.4-0.3c-0.3,0.1-0.6,0.2-0.9,0.2c-0.6-0.1-1.2-0.2-1.9-0.3c-1.1-0.1-1.5,0.1-1.9,0.8
        		c0,0.1-0.3,0.1-0.5,0.1c0-0.3,0.1-0.6,0.1-1c-0.6,0.1-0.9,0.1-1.3,0.2c-0.3,0-0.7,0.2-0.9,0.1c-0.3-0.1-0.3-0.4-0.6-0.7
        		c-0.6,0.3-1.1,0.5-1.6,0.8c-0.5-0.1-1.1-0.1-1.7-0.2c-1.4-0.3-1.4-0.3-2.2,0.3c-0.5-0.5-1.4-0.6-2.1-0.4c-0.7,0.2-1.2,0.1-1.8,0.1
        		c-0.8,0-1.6-0.2-2.4,0.1c-0.5,0.2-1,0-1.4-0.1C49.6,0.4,49.2,0.5,49,1c-1.6,0.3-2.8-0.5-4.4-0.6c0.2,0.3,0.2,0.4,0.3,0.6
        		c-1.2,0.2-1.8-0.1-2.2-0.7c-0.7,0.3-1,0.3-2.1,0.3c-0.1,0-0.4,0-0.4,0c-0.6,0.5-1.2,0.2-1.8,0c-0.3-0.1-1.1-0.1-1.1,0
        		c-0.2,0.5-1,0.2-1.2,0.3c-0.7,0.5-1.1-0.2-1.7-0.1c-0.6,0.1-1.2,0.3-2-0.1c-0.4-0.2-1.4-0.1-2.1,0.1c-0.9,0.1-1.6-0.2-2.4-0.4
        		c-0.2,0.2-0.4,0.4-0.6,0.5c-0.6-0.2-1-0.4-1.5-0.6c-0.6,0.8-1.5,0.7-2.5,0.4c-0.4-0.1-0.9-0.2-1.4-0.3c0.2,0.3,0.3,0.4,0.4,0.7
        		c-0.8-0.1-1.6,0-1.8-0.2c-0.8-0.6-1.3-0.4-2.2-0.1c-0.8,0.3-1.9,0.3-2.9,0.3c-0.5,0-0.9-0.4-1.4-0.6C13.1,1,12.4,1.2,11.8,1
        		c-1-0.2-3-0.3-4-0.1C7.1,1,6.6,0.9,6.3,0.5c0-0.1-0.2-0.1-0.4-0.2c0,0.2,0,0.3,0,0.5C4.6,0.7,3.4,0.6,2.6,0.5
        		C1.9,0.9,1.5,1,1.2,1.2C0.7,1.5,0.1,1.8,0,2.1l1.4,0.5c0.9,0.1,2.1,0.2,3.5,0.3c0-0.2,0-0.3,0-0.6c0.2,0.1,0.4,0.1,0.5,0.2
        		C5.6,3,6.1,3.1,6.9,2.9c0.4-0.1,1-0.1,1.7-0.1c0.1,0,0.2,0,0.3,0c0,0,0,0,0,0c0.8,0,1.6,0.1,2.1,0.2c0.7,0.1,1.4,0,2.2-0.6
        		c0.5,0.2,0.9,0.6,1.4,0.6c1,0,2.2,0,3-0.3c1-0.3,1.5-0.5,2.3,0.1C20.2,3.1,21,3,21.8,3.1c-0.2-0.3-0.3-0.5-0.4-0.7
        		c0.6,0.1,1.1,0.2,1.5,0.3c1,0.3,2,0.4,2.6-0.4c0.1,0,0.2,0.1,0.2,0.1c0,0,0,0,0,0c0-0.1,0.2-0.1,0.4-0.3c0.1,0.2,0.1,0.3,0.1,0.4
        		c0,0,0,0-0.1,0c0.3,0.1,0.6,0.2,0.9,0.4c0.2-0.2,0.4-0.4,0.6-0.5c0.8,0.3,1.5,0.6,2.4,0.4c0.7-0.1,1.8-0.3,2.2-0.1
        		c0.8,0.4,1.4,0.2,2,0.1c0.7-0.1,1,0.6,1.8,0.1c0.1-0.1,1,0.2,1.2-0.3c0,0,0.2,0,0.3,0c-0.1-0.1-0.2-0.2-0.2-0.2
        		c0-0.1,0.2-0.1,0.3-0.2C37.8,2.2,38,2.3,38,2.3c0,0.1-0.1,0.1-0.2,0.2c0.2,0,0.5,0,0.7,0.1c0.7,0.2,1.2,0.5,1.9,0
        		c0.1-0.1,0.3-0.1,0.4,0c1.1,0.1,1.4,0,2.1-0.3c0.4,0.6,1,0.9,2.3,0.7c-0.1-0.2-0.2-0.3-0.4-0.6c1.6,0.1,2.9,0.9,4.6,0.6
        		c0.2-0.5,0.6-0.6,1.4-0.4c0.5,0.1,0.9,0.3,1.5,0.1c0.8-0.3,1.6-0.1,2.5-0.1c0.6,0,1.2,0.1,1.9-0.1c0.7-0.2,1.7-0.1,2.2,0.4
        		c0.8-0.7,0.8-0.7,2.3-0.4c0.6,0.1,1.3,0.2,1.8,0.2c0.6-0.3,1.1-0.5,1.7-0.8c0.3,0.3,0.3,0.6,0.6,0.7c0.2,0.1,0.6,0,0.9-0.1
        		c0.4-0.1,0.8-0.1,1.4-0.2c0,0.4-0.1,0.7-0.1,1.1C67.8,3.6,68,3.5,68,3.5c0.4-0.7,0.9-0.9,2-0.8C70.7,2.7,71.3,2.9,72,3
        		c0.3,0,0.5-0.1,0.9-0.2c0.1,0,0.2,0.2,0.4,0.3c0.2,0.1,0.4,0.2,0.6,0.3C74.1,3.2,74.3,3,74.6,3c0.4,0,0.8,0,1-0.3
        		c0.2-0.3,0.6-0.3,1-0.1c0.9,0.5,2.1,0,3.1,0.4c0.6-0.7,1.5-0.3,2.3-0.2c0.4,0.1,0.8,0,1.3,0.1c0.3,0,0.7,0.1,1.1,0.1
        		c0.2-0.2,0.4-0.3,0.7-0.5c0.7,0.2,1.4,0.4,2.2,0.6c0.5-0.2,1-0.5,1.6-0.7c0.3,0.2,0.6,0.4,0.9,0.6c0.7,0.2,0.9-0.5,1.7-0.3
        		c0.5,0.1,1.1,0.1,1.8,0.2c1.3-0.3,2.6-0.4,4.1-0.1c1,0.2,2.1,0.1,3.3-0.4c0.2,0.3,0.4,0.5,0.6,0.8c0.5-0.3,0.8-0.5,1.2-0.8
        		c0.3,0.2,0.5,0.4,0.7,0.5c0.6-0.2,1.2-0.4,1.9-0.5c0.1,0.1,0.3,0.2,0.5,0.4c0.4-0.1,0.9-0.2,1.5-0.4c0.3,0.2,0.5,0.4,0.9,0.7
        		c0,0,0,0,0,0c-0.2-0.2-0.1-0.5,0.1-0.8c0.1,0.2,0.3,0.4,0.4,0.6c0.7-0.2,1.1,0.3,1.6,0.6c0.5-0.3,0.6-1,1.8-0.5
        		c0.9,0.4,1.3-0.3,2-0.5c0.6,0.6,1.5,0.8,2.7,0.6c0-0.2,0-0.3,0-0.4c1.2-0.2,2.6,0.5,3.7-0.2c0.7,0.3,1.4,0.6,2.1,1
        		c0.2-0.3,0.4-0.5,0.7-0.8c1,0.7,2.5-0.1,3.4,0.6c0.4-0.4,0.7-0.6,1.1-1c0.1,0.9,0.3,0.9,1.8,0.5c0.7,0.2,1.4,0.9,2.3,0.1
        		c0.1-0.1,0.7,0,1,0.1c0.7,0.1,1.4,0.4,2.1,0.3c0.1,0,0.3-0.1,0.4-0.1c0,0,0,0,0,0c0.1,0,0.1,0,0.2-0.1c1.6,0.3,3.2-0.1,4.8-0.1
        		c1.2,0,2.5,0.3,3.8,0.1c0.1,0,0.3,0.3,0.5,0.5c0.7-0.4,1.5-0.8,2.7-0.6c0.2,0,0.5,0,0.7-0.1c1.1-0.5,1.9-0.3,2.7,0.3
        		c0.7-0.4,1.3-1.1,2.3-0.3c1.4-0.2,2.9,0.5,4.2-0.2c0.2-0.1,0.6,0,0.9,0c2.1,0.3,4.3,0.1,6.4,0.3c0.5,0,1.1-0.2,1.7-0.4
        		c0.2,0.1,0.5,0.4,0.9,0.4c0.4,0,0.9-0.1,1.5-0.2c0.2,0.2,0.4,0.4,0.5,0.5c0.4-0.2,0.9-0.4,1.3-0.6c0.1,0,0.2-0.1,0.3-0.1
        		c0.8,0.2,1.5,0.3,2.4,0.5c0.1-0.3,0.2-0.5,0.2-0.8c0.3,0.1,0.6,0.1,0.8,0.2c0.7,0.3,1.5,0.3,2.3,0.2c0.7-0.1,1.5,0.1,2.5,0.2
        		c0,0,0.2-0.2,0.5-0.5c0.4,0.2,0.6,0.4,0.9,0.6c0.2,0,0.4-0.1,0.7-0.2c-0.1-0.1-0.2-0.1-0.3-0.2c0.4,0,0.6,0.1,0.8,0.1
        		c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.1,0.1,0.2,0.1c-0.2-0.3,0.1-0.5,0.7-0.7c0.1,0.3,0.1,0.5,0.2,0.8c-0.3,0-0.6,0-0.8-0.1
        		c0.9,0.5,2.3-0.1,3.5,0.2c1.7-0.5,3.4-0.2,5.1,0.1c0-0.2,0.1-0.4,0.1-0.6c2.4,0.4,2.4,0.4,3.5,0c0.3,0.1,0.6,0.3,0.9,0.3
        		c0.7,0.1,1.4-0.2,2,0.1c0.1,0,0.3,0,0.3,0c0.9-0.5,1.7-0.2,2.6,0c0.3,0.1,0.7-0.1,1-0.1c0.5,0,0.9,0,1.5,0
        		c-0.1-0.6,0.6-0.5,1.3-0.5c0.1,0.2,0.2,0.4,0.4,0.7c0.4-0.3,0.7-0.5,1.1-0.7c0.6,0.2,1.1,0.4,1.8,0.7c0.3-0.6,1.1-0.5,1.8-0.4
        		c0.5,0.1,1,0.2,1.5,0.3c0.8,0.2,1.3,0,1.6-0.4c0.5,0.1,0.9,0.3,1.4,0.3c0.4,0,0.9-0.1,1.5-0.2c0.8,0.7,2.2,0.4,3.5,0.3
        		c1.2-0.1,2.4-0.3,3.7,0c0.6,0.1,1.5-0.1,2.4-0.2c0,0,0.2,0.2,0.3,0.4c0.5-0.2,0.8-0.2,1-0.3c0.3-0.1,0.5-0.2,0.8-0.4
        		c0.3,0.2,0.5,0.3,0.9,0.5c1.6-0.4,3.1-0.4,4.5,0.5c0.2-0.4,0.3-0.7,0.5-1.1c0.5,0.4,0.9,0.5,1.6,0.5c1.1-0.1,2.3-0.2,3.5,0.2
        		c0.3,0.1,1-0.1,1.4-0.2c0.3,0,0.6,0.1,0.9,0.2c0-0.1,0-0.2,0-0.3c-0.1-0.5-0.3-0.8-1.2-1c-0.3-0.1-0.5-0.2-0.8-0.3
        		C237.8,1,237.5,1.3,237.4,1.2z M9.6,2.3c-0.8,0.1-1.1,0-0.9-0.6C9.1,2,9.3,2.1,9.6,2.3z M13.9,1.4c-0.1,0-0.3-0.1-0.4-0.1
        		c0.1-0.1,0.2-0.1,0.3-0.2c0.2,0.1,0.3,0.1,0.4,0.2C14.2,1.3,14.1,1.4,13.9,1.4z M19.7,2.2c0,0-0.2,0-0.3,0c0-0.1-0.1-0.3-0.1-0.4
        		c0.1,0,0.3,0,0.4,0C19.7,2,19.7,2.1,19.7,2.2z M23.9,2c-0.2-0.5-0.2-0.5,0.7-0.5C24.3,1.7,24.1,1.8,23.9,2z M40.1,2.7
        		c0,0.1-0.2,0.1-0.3,0.2c-0.1-0.1-0.2-0.2-0.2-0.2c0-0.1,0.2-0.1,0.3-0.2C40.1,2.5,40.2,2.6,40.1,2.7z M42.3,1.4
        		c-0.2,0-0.3-0.1-0.4-0.2C42,1.1,42.1,1.1,42.3,1c0.1,0.1,0.3,0.2,0.4,0.3C42.5,1.3,42.4,1.4,42.3,1.4z M49.9,2.3
        		c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1-0.1-0.3-0.1-0.3-0.2c0-0.1,0.1-0.1,0.2-0.2C49.6,2.2,49.7,2.2,49.9,2.3z M107.8,2.1
        		c-0.7,0.2-0.8,0-0.7-0.6C107.5,1.8,107.7,1.9,107.8,2.1z M137.7,1.7c0.3-0.3,0.5-0.6,1.3-0.4C138.7,1.6,138.6,2,137.7,1.7z"
            />
            <path
                fill={color}
                d="M110.5,4.1c-0.2-0.1-0.3-0.3-0.7-0.6C109.6,4.1,109.8,4.3,110.5,4.1z"
            />
            <path
                fill={color}
                d="M141.4,3.8c0.9,0.3,1.1-0.1,1.4-0.4C142,3.2,141.7,3.5,141.4,3.8z"
            />
            <path
                fill={color}
                d="M25.5,4.7c0.1,0,0.4-0.1,0.4-0.1c0-0.1,0-0.2-0.1-0.4c-0.2,0.2-0.4,0.2-0.4,0.3C25.4,4.5,25.5,4.6,25.5,4.7z"
            />
            <path fill={color} d="M23.5,4.1c0.3-0.2,0.5-0.3,0.7-0.5C23.2,3.6,23.2,3.6,23.5,4.1z" />
            <path
                fill={color}
                d="M18.9,4.3c0.1,0,0.3,0,0.3,0c0-0.1,0-0.3,0.1-0.4c-0.1,0-0.3,0-0.4,0C18.8,4,18.8,4.2,18.9,4.3z"
            />
            <path
                fill={color}
                d="M12.8,3.4c0.1,0,0.3,0.1,0.4,0.1c0.1,0,0.2-0.1,0.4-0.2c-0.1-0.1-0.3-0.1-0.4-0.2C13,3.2,12.9,3.3,12.8,3.4z"
            />
            <path
                fill={color}
                d="M42.1,3.2c0.2,0.1,0.3,0.2,0.5,0.2c0.1,0,0.3-0.1,0.4-0.1c-0.1-0.1-0.2-0.2-0.4-0.3
        		C42.3,3.1,42.2,3.2,42.1,3.2z"
            />
            <path
                fill={color}
                d="M49.8,4.4c0,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.2-0.1,0.3-0.3c-0.2-0.1-0.3-0.1-0.4-0.2
        		C49.9,4.3,49.8,4.3,49.8,4.4z"
            />
            <path
                fill={color}
                d="M58.3,5.8c0,0.1,0.2,0.2,0.3,0.2C58.8,6,59,5.9,59,5.8c0-0.1-0.1-0.2-0.3-0.5C58.4,5.6,58.3,5.7,58.3,5.8z"
            />
            <path
                fill={color}
                d="M40,4.9c0.1-0.1,0.3-0.1,0.3-0.2c0-0.1-0.1-0.2-0.2-0.3c-0.2,0.1-0.3,0.2-0.3,0.3C39.8,4.8,39.9,4.9,40,4.9z"
            />
            <path
                fill={color}
                d="M38.1,4.4c0-0.1-0.2-0.1-0.3-0.2c-0.1,0.1-0.3,0.1-0.3,0.2c0,0.1,0.1,0.2,0.3,0.3C38,4.6,38.1,4.5,38.1,4.4z"
            />
            <path
                fill={color}
                d="M42,6c0.1,0,0.2-0.1,0.3-0.2c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1,0.1-0.2,0.2-0.3,0.2C41.8,5.9,41.9,6,42,6z"
            />
        </g>
    </svg>
);

LineLargeAlt.propTypes = propTypes;
LineLargeAlt.defaultProps = defaultProps;

export default LineLargeAlt;
